var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" }
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "名称" } }),
          _c("el-table-column", {
            attrs: { prop: "age_group", label: "年龄组" }
          }),
          _c("el-table-column", {
            attrs: { prop: "start_date_format", label: "开始时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "end_date_format", label: "结束时间" }
          }),
          _c("el-table-column", {
            attrs: { prop: "entry_fee", label: "费用" }
          }),
          _c("el-table-column", {
            attrs: { prop: "max_teams", label: "最大球队" }
          }),
          _c("el-table-column", {
            attrs: { prop: "registration_status_text", label: "赛事状态" }
          }),
          _c("el-table-column", {
            attrs: { prop: "format", label: "赛制规则" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.formatMap[row.format]))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "tournament_type", label: "赛事类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.tournamentMap[row.tournament_type]))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "赛事描述" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "120",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "x-c" },
                      [
                        scope.row.registration_status == "open"
                          ? [
                              scope.row.registrations.length == 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "controlsBtn",
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.addTourRegister.init(
                                            scope.row.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" 报名 ")]
                                  )
                                : _c("div", { staticClass: "controlsBtn" }, [
                                    _vm._v(" 已报名 ")
                                  ])
                            ]
                          : _vm._e(),
                        scope.row.status == 1 || scope.row.status == 2
                          ? _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.courseList.init(
                                      scope.row.id
                                    )
                                  }
                                }
                              },
                              [_vm._v(" 赛程 ")]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": 10
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addTourRegister", {
        ref: "addTourRegister",
        attrs: { teamId: _vm.teamId },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("courseList", { ref: "courseList", attrs: { teamId: _vm.teamId } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }